// extracted by mini-css-extract-plugin
export var background = "bF_y";
export var backgroundContainer = "bF_fC";
export var bottomWave = "bF_cV";
export var buttons = "bF_cr";
export var container = "bF_b";
export var content = "bF_b8";
export var icon = "bF_bq";
export var iconContainer = "bF_dy";
export var middleWave = "bF_cT";
export var negativeTop = "bF_hb";
export var overlap = "bF_hd";
export var section = "bF_d";
export var selected = "bF_bg";
export var tab = "bF_ff";
export var tabText = "bF_fd";
export var title = "bF_h";
export var topWave = "bF_hc";